module.exports = __webpack_public_path__ + "img/fi-rr-volleyball.7e19b10f.svg";